function cov_hg5r3ks18() {
  var path = "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_icons/NavExitLinkIcon.tsx";
  var hash = "234599b0d60c90d28c51c9e1040e426b69c0c270";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_icons/NavExitLinkIcon.tsx",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 39
        },
        end: {
          line: 23,
          column: 1
        }
      },
      "1": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 22,
          column: 9
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 39
          },
          end: {
            line: 7,
            column: 40
          }
        },
        loc: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 22,
            column: 9
          }
        },
        line: 8
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "234599b0d60c90d28c51c9e1040e426b69c0c270"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_hg5r3ks18 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_hg5r3ks18();
import React from 'react';
import { Flex } from '../../core';
import { colors } from '../../theme/eero';
/** @deprecated */

cov_hg5r3ks18().s[0]++;

var NavExitLinkIcon = function NavExitLinkIcon(props) {
  cov_hg5r3ks18().f[0]++;
  cov_hg5r3ks18().s[1]++;
  return /*#__PURE__*/React.createElement(Flex, props, /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "Nav Exit Link Icon"), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33333 11C2.33333 11.3667 2.63333 11.6667 3 11.6667H11C11.3667 11.6667 11.6667 11.3667 11.6667 11V7.66667C11.6667 7.3 11.9667 7 12.3333 7C12.7 7 13 7.3 13 7.66667V11.6667C13 12.4 12.4 13 11.6667 13H2.33333C1.6 13 1 12.4 1 11.6667V2.33333C1 1.6 1.59333 1 2.33333 1H6.33333C6.7 1 7 1.3 7 1.66667C7 2.03333 6.7 2.33333 6.33333 2.33333H3C2.63333 2.33333 2.33333 2.63333 2.33333 3V11ZM9 2.33333C8.63333 2.33333 8.33333 2.03333 8.33333 1.66667C8.33333 1.3 8.63333 1 9 1H12.3333C12.7 1 13 1.3 13 1.66667V5C13 5.36667 12.7 5.66667 12.3333 5.66667C11.9667 5.66667 11.6667 5.36667 11.6667 5V3.27333L5.58 9.36C5.32 9.62 4.9 9.62 4.64 9.36C4.38 9.1 4.38 8.68 4.64 8.42L10.7267 2.33333H9Z",
    fill: colors.brand50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 3.27333H11.9167V2.66978L11.4899 3.09656L11.6667 3.27333ZM5.58 9.36L5.75678 9.53678H5.75678L5.58 9.36ZM4.64 9.36L4.46322 9.53678H4.46322L4.64 9.36ZM4.64 8.42L4.46322 8.24322L4.46322 8.24322L4.64 8.42ZM10.7267 2.33333L10.9034 2.51011L11.3302 2.08333H10.7267V2.33333ZM3 11.4167C2.7714 11.4167 2.58333 11.2286 2.58333 11H2.08333C2.08333 11.5047 2.49526 11.9167 3 11.9167V11.4167ZM11 11.4167H3V11.9167H11V11.4167ZM11.4167 11C11.4167 11.2286 11.2286 11.4167 11 11.4167V11.9167C11.5047 11.9167 11.9167 11.5047 11.9167 11H11.4167ZM11.4167 7.66667V11H11.9167V7.66667H11.4167ZM12.3333 6.75C11.8286 6.75 11.4167 7.16193 11.4167 7.66667H11.9167C11.9167 7.43807 12.1047 7.25 12.3333 7.25V6.75ZM13.25 7.66667C13.25 7.16193 12.8381 6.75 12.3333 6.75V7.25C12.5619 7.25 12.75 7.43807 12.75 7.66667H13.25ZM13.25 11.6667V7.66667H12.75V11.6667H13.25ZM11.6667 13.25C12.5381 13.25 13.25 12.5381 13.25 11.6667H12.75C12.75 12.2619 12.2619 12.75 11.6667 12.75V13.25ZM2.33333 13.25H11.6667V12.75H2.33333V13.25ZM0.75 11.6667C0.75 12.5381 1.46193 13.25 2.33333 13.25V12.75C1.73807 12.75 1.25 12.2619 1.25 11.6667H0.75ZM0.75 2.33333V11.6667H1.25V2.33333H0.75ZM2.33333 0.75C1.45445 0.75 0.75 1.46274 0.75 2.33333H1.25C1.25 1.73726 1.73222 1.25 2.33333 1.25V0.75ZM6.33333 0.75H2.33333V1.25H6.33333V0.75ZM7.25 1.66667C7.25 1.16193 6.83807 0.75 6.33333 0.75V1.25C6.56193 1.25 6.75 1.43807 6.75 1.66667H7.25ZM6.33333 2.58333C6.83807 2.58333 7.25 2.1714 7.25 1.66667H6.75C6.75 1.89526 6.56193 2.08333 6.33333 2.08333V2.58333ZM3 2.58333H6.33333V2.08333H3V2.58333ZM2.58333 3C2.58333 2.7714 2.7714 2.58333 3 2.58333V2.08333C2.49526 2.08333 2.08333 2.49526 2.08333 3H2.58333ZM2.58333 11V3H2.08333V11H2.58333ZM8.08333 1.66667C8.08333 2.1714 8.49526 2.58333 9 2.58333V2.08333C8.7714 2.08333 8.58333 1.89526 8.58333 1.66667H8.08333ZM9 0.75C8.49526 0.75 8.08333 1.16193 8.08333 1.66667H8.58333C8.58333 1.43807 8.7714 1.25 9 1.25V0.75ZM12.3333 0.75H9V1.25H12.3333V0.75ZM13.25 1.66667C13.25 1.16193 12.8381 0.75 12.3333 0.75V1.25C12.5619 1.25 12.75 1.43807 12.75 1.66667H13.25ZM13.25 5V1.66667H12.75V5H13.25ZM12.3333 5.91667C12.8381 5.91667 13.25 5.50474 13.25 5H12.75C12.75 5.2286 12.5619 5.41667 12.3333 5.41667V5.91667ZM11.4167 5C11.4167 5.50474 11.8286 5.91667 12.3333 5.91667V5.41667C12.1047 5.41667 11.9167 5.2286 11.9167 5H11.4167ZM11.4167 3.27333V5H11.9167V3.27333H11.4167ZM5.75678 9.53678L11.8434 3.45011L11.4899 3.09656L5.40322 9.18322L5.75678 9.53678ZM4.46322 9.53678C4.82085 9.89441 5.39915 9.89441 5.75678 9.53678L5.40322 9.18322C5.24085 9.34559 4.97915 9.34559 4.81678 9.18322L4.46322 9.53678ZM4.46322 8.24322C4.10559 8.60085 4.10559 9.17915 4.46322 9.53678L4.81678 9.18322C4.65441 9.02085 4.65441 8.75915 4.81678 8.59678L4.46322 8.24322ZM10.5499 2.15656L4.46322 8.24322L4.81678 8.59678L10.9034 2.51011L10.5499 2.15656ZM9 2.58333H10.7267V2.08333H9V2.58333Z",
    fill: colors.brand50
  })));
};

export default NavExitLinkIcon;